<!-- my-loader.component.html -->
<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <div class="containerLoaderItems">
            <img class="imgLoader" src="../../../../assets//images/logo_vitro_rounded.png" alt="vitro Proof">
            <div class="dotsContainer">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
            </div>
        </div>
    </div>
</div>